(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-piezas-editorial"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('editorial-product-loop')) {

  customElements.define(
    'editorial-product-loop',

    class EditorialProductLoop extends HTMLElement {

      connectedCallback() {

        if (
          this.dataset.loopReady === 'true'
        ) {
          return;
        }


        this.dataset.loopReady =
          'true';


        this.viewport =
          this.querySelector(
            '[data-loop-viewport]'
          );


        this.track =
          this.querySelector(
            '[data-loop-track]'
          );


        this.cards =
          Array.from(
            this.querySelectorAll(
              '[data-loop-card]'
            )
          );


        /* ==================================
           REVEAL
        ================================== */

        this.classList.add(
          'is-reveal-ready'
        );


        if (
          'IntersectionObserver'
          in window
        ) {

          this.revealObserver =
            new IntersectionObserver(

              (entries) => {

                entries.forEach(
                  (entry) => {

                    if (
                      entry.isIntersecting
                    ) {

                      this.classList.add(
                        'is-visible'
                      );


                      this.revealObserver
                        .unobserve(this);

                    }

                  }
                );

              },

              {
                threshold: 0.08
              }

            );


          this.revealObserver
            .observe(this);

        } else {

          this.classList.add(
            'is-visible'
          );

        }


        if (
          !this.viewport ||
          !this.track ||
          this.cards.length < 2
        ) {
          return;
        }


        /* ==================================
           LOOP INFINITO

           Creamos:

           copia
           copia
           ORIGINAL
           copia
           copia

           Así el paso:

           3 → 4 → 1 → 2

           ocurre físicamente seguido
           y no necesita ningún salto.
        ================================== */

        this.beforeGroups = [];

        this.afterGroups = [];


        const beforeFragment =
          document.createDocumentFragment();


        const afterFragment =
          document.createDocumentFragment();


        /* DOS COPIAS ANTES */

        for (
          let group = 0;
          group < 2;
          group++
        ) {

          const clones = [];


          this.cards.forEach(
            (card) => {

              const clone =
                this.createClone(card);


              clones.push(clone);


              beforeFragment
                .appendChild(clone);

            }
          );


          this.beforeGroups.push(
            clones
          );

        }


        /* DOS COPIAS DESPUÉS */

        for (
          let group = 0;
          group < 2;
          group++
        ) {

          const clones = [];


          this.cards.forEach(
            (card) => {

              const clone =
                this.createClone(card);


              clones.push(clone);


              afterFragment
                .appendChild(clone);

            }
          );


          this.afterGroups.push(
            clones
          );

        }


        this.track.insertBefore(
          beforeFragment,
          this.cards[0]
        );


        this.track.appendChild(
          afterFragment
        );


        /* ==================================
           EVENTS
        ================================== */

        this.handleScroll =
          this.handleScroll.bind(this);


        this.handleScrollEnd =
          this.handleScrollEnd.bind(this);


        this.handleResize =
          this.handleResize.bind(this);


        this.viewport.addEventListener(
          'scroll',
          this.handleScroll,
          {
            passive: true
          }
        );


        if (
          'onscrollend'
          in this.viewport
        ) {

          this.viewport.addEventListener(
            'scrollend',
            this.handleScrollEnd
          );

        }


        window.addEventListener(
          'resize',
          this.handleResize,
          {
            passive: true
          }
        );


        /* ==================================
           INITIAL POSITION
        ================================== */

        window.requestAnimationFrame(
          () => {

            window.requestAnimationFrame(
              () => {

                this.measureLoop();


                this.teleport(
                  this.middleStart
                );

              }
            );

          }
        );

      }


      /* ==================================
         CREATE CLONE
      ================================== */

      createClone(card) {

        const clone =
          card.cloneNode(true);


        clone.setAttribute(
          'data-loop-clone',
          ''
        );


        clone.setAttribute(
          'aria-hidden',
          'true'
        );


        clone.removeAttribute(
          'data-shopify-editor-block'
        );


        clone
          .querySelectorAll(
            'a, button, input, select, textarea'
          )
          .forEach(
            (element) => {

              element.setAttribute(
                'tabindex',
                '-1'
              );

            }
          );


        return clone;

      }


      /* ==================================
         TRACK PADDING
      ================================== */

      getTrackLeftPadding() {

        const styles =
          window.getComputedStyle(
            this.track
          );


        return (
          parseFloat(
            styles.paddingLeft
          ) || 0
        );

      }


      /* ==================================
         CARD POSITION
      ================================== */

      getCardPosition(card) {

        return (
          card.offsetLeft -
          this.getTrackLeftPadding()
        );

      }


      /* ==================================
         LOOP MEASUREMENTS
      ================================== */

      measureLoop() {

        if (
          !this.cards.length ||
          !this.afterGroups.length
        ) {
          return;
        }


        this.middleStart =
          this.getCardPosition(
            this.cards[0]
          );


        const nextGroupStart =
          this.getCardPosition(
            this.afterGroups[0][0]
          );


        this.cycleWidth =
          nextGroupStart -
          this.middleStart;


        /*
          Dejamos una vuelta completa
          a cada lado antes de recentrar.
        */

        this.leftSafeStart =
          this.middleStart -
          this.cycleWidth;


        this.rightResetStart =
          this.middleStart +
          (
            this.cycleWidth * 2
          );

      }


      /* ==================================
         SCROLL
      ================================== */

      handleScroll() {

        window.clearTimeout(
          this.scrollTimer
        );


        /*
          No tocamos nada mientras
          el usuario está deslizando.

          Esperamos a que termine
          toda la inercia.
        */

        this.scrollTimer =
          window.setTimeout(
            () => {

              this.correctLoop();

            },
            180
          );

      }


      handleScrollEnd() {

        window.clearTimeout(
          this.scrollTimer
        );


        this.scrollTimer =
          window.setTimeout(
            () => {

              this.correctLoop();

            },
            40
          );

      }


      /* ==================================
         RECENTER LOOP
      ================================== */

      correctLoop() {

        if (
          !this.cycleWidth
        ) {

          this.measureLoop();

        }


        if (
          !this.cycleWidth
        ) {
          return;
        }


        const current =
          this.viewport.scrollLeft;


        /*
          Solo recentramos cuando estamos
          muy lejos del grupo central.

          Nunca durante el cambio 4 → 1.
        */

        if (
          current <
          this.leftSafeStart
        ) {

          this.teleport(
            this.getEquivalentMiddlePosition(
              current
            )
          );


          return;

        }


        if (
          current >=
          this.rightResetStart
        ) {

          this.teleport(
            this.getEquivalentMiddlePosition(
              current
            )
          );

        }

      }


      /* ==================================
         EQUIVALENT MIDDLE POSITION
      ================================== */

      getEquivalentMiddlePosition(
        position
      ) {

        let offset =
          position -
          this.middleStart;


        offset =
          (
            (
              offset %
              this.cycleWidth
            ) +
            this.cycleWidth
          ) %
          this.cycleWidth;


        return (
          this.middleStart +
          offset
        );

      }


      /* ==================================
         INVISIBLE TELEPORT
      ================================== */

      teleport(position) {

        if (
          !this.viewport
        ) {
          return;
        }


        this.viewport
          .classList
          .add(
            'is-teleporting'
          );


        this.viewport.scrollLeft =
          position;


        window.requestAnimationFrame(
          () => {

            window.requestAnimationFrame(
              () => {

                this.viewport
                  .classList
                  .remove(
                    'is-teleporting'
                  );

              }
            );

          }
        );

      }


      /* ==================================
         RESIZE
      ================================== */

      handleResize() {

        window.clearTimeout(
          this.resizeTimer
        );


        this.resizeTimer =
          window.setTimeout(
            () => {

              this.measureLoop();


              this.teleport(
                this.middleStart
              );

            },
            180
          );

      }


      /* ==================================
         CLEANUP
      ================================== */

      disconnectedCallback() {

        window.clearTimeout(
          this.scrollTimer
        );


        window.clearTimeout(
          this.resizeTimer
        );


        if (
          this.viewport &&
          this.handleScroll
        ) {

          this.viewport
            .removeEventListener(
              'scroll',
              this.handleScroll
            );

        }


        if (
          this.viewport &&
          this.handleScrollEnd
        ) {

          this.viewport
            .removeEventListener(
              'scrollend',
              this.handleScrollEnd
            );

        }


        if (
          this.handleResize
        ) {

          window
            .removeEventListener(
              'resize',
              this.handleResize
            );

        }


        if (
          this.revealObserver
        ) {

          this.revealObserver
            .disconnect();

        }

      }

    }

  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-premium"] && !Shopify.designMode) return;
  try {
    

if (
  !customElements.get(
    'premium-product-carousel'
  )
) {

  customElements.define(
    'premium-product-carousel',

    class ProductCarousel
      extends HTMLElement {


      connectedCallback() {

        this.querySelectorAll(
          '[data-carousel-loop-clone]'
        ).forEach(
          (clone) => clone.remove()
        );


        this.viewport =
          this.querySelector(
            '[data-carousel-viewport]'
          );


        this.track =
          this.querySelector(
            '[data-carousel-track]'
          );


        this.slides =
          Array.from(
            this.querySelectorAll(
              '[data-carousel-slide]'
            )
          );


        this.dots =
          Array.from(
            this.querySelectorAll(
              '[data-carousel-dot]'
            )
          );


        if (
          !this.viewport ||
          !this.track ||
          this.slides.length === 0
        ) {
          return;
        }


        this.slideCount =
          this.slides.length;


        if (
          this.slideCount < 2
        ) {

          this.setDot(
            0
          );

          return;

        }


        this.isTouching =
          false;


        this.isRecentering =
          false;


        this.scrollTimer =
          null;


        this.resizeTimer =
          null;


        this.dotFrame =
          null;


        this.slides.forEach(
          (slide, index) => {

            slide.dataset.logicalIndex =
              index;

          }
        );


        this.beforeGroups =
          [];


        this.afterGroups =
          [];


        const beforeFragment =
          document.createDocumentFragment();


        const afterFragment =
          document.createDocumentFragment();


        for (
          let group = 0;
          group < 2;
          group++
        ) {

          const currentGroup =
            [];


          this.slides.forEach(
            (slide, index) => {

              const clone =
                this.createClone(
                  slide,
                  index
                );


              currentGroup.push(
                clone
              );


              beforeFragment.appendChild(
                clone
              );

            }
          );


          this.beforeGroups.push(
            currentGroup
          );

        }


        for (
          let group = 0;
          group < 2;
          group++
        ) {

          const currentGroup =
            [];


          this.slides.forEach(
            (slide, index) => {

              const clone =
                this.createClone(
                  slide,
                  index
                );


              currentGroup.push(
                clone
              );


              afterFragment.appendChild(
                clone
              );

            }
          );


          this.afterGroups.push(
            currentGroup
          );

        }


        this.track.insertBefore(
          beforeFragment,
          this.slides[0]
        );


        this.track.appendChild(
          afterFragment
        );


        this.dots.forEach(
          (dot) => {

            dot.addEventListener(
              'click',

              () => {

                this.goToLogical(
                  Number(
                    dot.dataset.index
                  )
                );

              }
            );

          }
        );


        this.onScroll =
          this.onScroll.bind(this);


        this.onScrollEnd =
          this.onScrollEnd.bind(this);


        this.onTouchStart =
          this.onTouchStart.bind(this);


        this.onTouchEnd =
          this.onTouchEnd.bind(this);


        this.onResize =
          this.onResize.bind(this);


        this.viewport.addEventListener(
          'scroll',
          this.onScroll,
          {
            passive: true
          }
        );


        if (
          'onscrollend'
          in this.viewport
        ) {

          this.viewport.addEventListener(
            'scrollend',
            this.onScrollEnd
          );

        }


        this.viewport.addEventListener(
          'touchstart',
          this.onTouchStart,
          {
            passive: true
          }
        );


        this.viewport.addEventListener(
          'touchend',
          this.onTouchEnd,
          {
            passive: true
          }
        );


        this.viewport.addEventListener(
          'touchcancel',
          this.onTouchEnd,
          {
            passive: true
          }
        );


        window.addEventListener(
          'resize',
          this.onResize,
          {
            passive: true
          }
        );


        window.requestAnimationFrame(
          () => {

            window.requestAnimationFrame(
              () => {

                this.measure();


                this.instantMove(
                  this.middleStart
                );


                this.updateDotFromScroll();

              }
            );

          }
        );

      }


      createClone(
        slide,
        logicalIndex
      ) {

        const clone =
          slide.cloneNode(
            true
          );


        clone.setAttribute(
          'data-carousel-loop-clone',
          ''
        );


        clone.dataset.logicalIndex =
          logicalIndex;


        clone.removeAttribute(
          'data-carousel-slide'
        );


        clone.setAttribute(
          'aria-hidden',
          'true'
        );


        clone.querySelectorAll(
          'a, button, input, select, textarea'
        ).forEach(
          (element) => {

            element.setAttribute(
              'tabindex',
              '-1'
            );

          }
        );


        return clone;

      }


      measure() {

        if (
          !this.afterGroups.length
        ) {
          return;
        }


        this.middleStart =
          this.slides[0]
            .offsetLeft;


        const nextCycleStart =
          this.afterGroups[0][0]
            .offsetLeft;


        this.cycleWidth =
          nextCycleStart -
          this.middleStart;


        if (
          !this.cycleWidth ||
          this.cycleWidth <= 0
        ) {
          return;
        }


        this.step =
          this.cycleWidth /
          this.slideCount;


        this.leftTrigger =
          this.middleStart -
          (
            this.step *
            0.55
          );


        this.rightTrigger =
          this.middleStart +
          this.cycleWidth -
          (
            this.step *
            0.45
          );

      }


      onTouchStart() {

        this.isTouching =
          true;


        window.clearTimeout(
          this.scrollTimer
        );

      }


      onTouchEnd() {

        this.isTouching =
          false;


        this.scheduleScrollEnd();

      }


      onScroll() {

        if (
          this.isRecentering
        ) {
          return;
        }


        if (
          !this.dotFrame
        ) {

          this.dotFrame =
            window.requestAnimationFrame(
              () => {

                this.updateDotFromScroll();


                this.dotFrame =
                  null;

              }
            );

        }


        if (
          !this.isTouching
        ) {

          this.scheduleScrollEnd();

        }

      }


      scheduleScrollEnd() {

        window.clearTimeout(
          this.scrollTimer
        );


        this.scrollTimer =
          window.setTimeout(
            () => {

              if (
                this.isTouching ||
                this.isRecentering
              ) {
                return;
              }


              this.recenterIfNeeded();

            },
            180
          );

      }


      onScrollEnd() {

        if (
          this.isTouching ||
          this.isRecentering
        ) {
          return;
        }


        window.clearTimeout(
          this.scrollTimer
        );


        window.requestAnimationFrame(
          () => {

            if (
              !this.isTouching
            ) {

              this.recenterIfNeeded();

            }

          }
        );

      }


      updateDotFromScroll() {

        if (
          !this.step ||
          this.dots.length === 0
        ) {
          return;
        }


        const rawIndex =
          Math.round(
            (
              this.viewport.scrollLeft -
              this.middleStart
            ) /
            this.step
          );


        const logicalIndex =
          this.mod(
            rawIndex,
            this.slideCount
          );


        this.setDot(
          logicalIndex
        );

      }


      setDot(
        logicalIndex
      ) {

        this.dots.forEach(
          (dot, index) => {

            const active =
              index ===
              logicalIndex;


            dot.classList.toggle(
              'is-active',
              active
            );


            dot.setAttribute(
              'aria-current',
              active
                ? 'true'
                : 'false'
            );

          }
        );

      }


      recenterIfNeeded() {

        if (
          !this.cycleWidth ||
          !this.step
        ) {
          return;
        }


        const current =
          this.viewport.scrollLeft;


        if (
          current >=
          this.rightTrigger
        ) {

          this.instantMove(
            this.getEquivalentMiddlePosition(
              current
            )
          );


          return;

        }


        if (
          current <=
          this.leftTrigger
        ) {

          this.instantMove(
            this.getEquivalentMiddlePosition(
              current
            )
          );

        }

      }


      getEquivalentMiddlePosition(
        position
      ) {

        const offset =
          this.mod(
            position -
            this.middleStart,
            this.cycleWidth
          );


        return (
          this.middleStart +
          offset
        );

      }


      instantMove(
        position
      ) {

        if (
          !this.viewport
        ) {
          return;
        }


        this.isRecentering =
          true;


        this.viewport.classList.add(
          'is-recentering'
        );


        this.viewport.scrollLeft =
          position;


        window.requestAnimationFrame(
          () => {

            this.viewport.classList.remove(
              'is-recentering'
            );


            this.isRecentering =
              false;


            this.updateDotFromScroll();

          }
        );

      }


      goToLogical(
        logicalIndex
      ) {

        if (
          !this.step ||
          !Number.isFinite(
            logicalIndex
          )
        ) {
          return;
        }


        const currentRawIndex =
          Math.round(
            (
              this.viewport.scrollLeft -
              this.middleStart
            ) /
            this.step
          );


        let bestRawIndex =
          logicalIndex;


        let bestDistance =
          Number.POSITIVE_INFINITY;


        for (
          let cycle = -2;
          cycle <= 2;
          cycle++
        ) {

          const candidate =
            logicalIndex +
            (
              cycle *
              this.slideCount
            );


          const distance =
            Math.abs(
              candidate -
              currentRawIndex
            );


          if (
            distance <
            bestDistance
          ) {

            bestDistance =
              distance;


            bestRawIndex =
              candidate;

          }

        }


        const target =
          this.middleStart +
          (
            bestRawIndex *
            this.step
          );


        this.viewport.scrollTo({

          left:
            target,

          behavior:
            'smooth'

        });

      }


      mod(
        value,
        divisor
      ) {

        return (
          (
            value %
            divisor
          ) +
          divisor
        ) %
        divisor;

      }


      onResize() {

        window.clearTimeout(
          this.resizeTimer
        );


        this.resizeTimer =
          window.setTimeout(
            () => {

              let logicalIndex =
                0;


              const activeDotIndex =
                this.dots.findIndex(
                  (dot) =>
                    dot.classList.contains(
                      'is-active'
                    )
                );


              if (
                activeDotIndex >= 0
              ) {

                logicalIndex =
                  activeDotIndex;

              }


              this.measure();


              if (
                this.step
              ) {

                this.instantMove(
                  this.middleStart +
                  (
                    logicalIndex *
                    this.step
                  )
                );

              }

            },
            180
          );

      }


      disconnectedCallback() {

        window.clearTimeout(
          this.scrollTimer
        );


        window.clearTimeout(
          this.resizeTimer
        );


        if (
          this.dotFrame
        ) {

          window.cancelAnimationFrame(
            this.dotFrame
          );

        }


        if (
          this.viewport
        ) {

          this.viewport.removeEventListener(
            'scroll',
            this.onScroll
          );


          this.viewport.removeEventListener(
            'scrollend',
            this.onScrollEnd
          );


          this.viewport.removeEventListener(
            'touchstart',
            this.onTouchStart
          );


          this.viewport.removeEventListener(
            'touchend',
            this.onTouchEnd
          );


          this.viewport.removeEventListener(
            'touchcancel',
            this.onTouchEnd
          );

        }


        window.removeEventListener(
          'resize',
          this.onResize
        );

      }

    }

  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    



if (

  !customElements.get(

    'graellsia-footer'

  )

) {



  customElements.define(

    'graellsia-footer',



    class GraellsiaFooter

      extends HTMLElement {





      connectedCallback() {



        this.accordions =

          Array.from(

            this.querySelectorAll(

              '.gf-accordion'

            )

          );





        this.accordions.forEach(

          (accordion) => {



            accordion.addEventListener(

              'toggle',



              () => {



                if (

                  !accordion.open

                ) {

                  return;

                }





                this.accordions.forEach(

                  (otherAccordion) => {



                    if (

                      otherAccordion !== accordion

                    ) {



                      otherAccordion.open =

                        false;



                    }



                  }

                );



              }

            );



          }

        );



      }



    }



  );



}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["franja-confianza"] && !Shopify.designMode) return;
  try {
    
  const initTrustStrip = (section) => {
    if (!section || section.dataset.initialized === 'true') return;
    const track = section.querySelector('.trust-strip__inner');
    const originals = [...section.querySelectorAll('.trust-strip__item')];
    if (!track || originals.length < 2) return;
    section.dataset.initialized = 'true';
    const clones = document.createDocumentFragment();
    originals.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clones.appendChild(clone);
    });
    track.append(clones);

    let setWidth = 0;
    let position = 0;
    let dragging = false;
    let pointerStart = 0;
    let positionStart = 0;
    let lastTime = performance.now();
    let resumeTimer;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const measure = () => {
      setWidth = originals.reduce((total, slide) => total + slide.getBoundingClientRect().width, 0);
      if (setWidth) position = ((position % setWidth) + setWidth) % setWidth;
      track.style.transform = `translate3d(${-position}px, 0, 0)`;
    };

    const normalize = () => {
      if (!setWidth) return;
      position = ((position % setWidth) + setWidth) % setWidth;
    };

    const frame = (time) => {
      const elapsed = Math.min(time - lastTime, 50);
      lastTime = time;
      if (!dragging && !reducedMotion) {
        position += (Number(section.dataset.speed) || 20) * elapsed / 1000;
        normalize();
      }
      track.style.transform = `translate3d(${-position}px, 0, 0)`;
      requestAnimationFrame(frame);
    };

    const beginDrag = (event) => {
      dragging = true;
      pointerStart = event.clientX;
      positionStart = position;
      clearTimeout(resumeTimer);
      track.setPointerCapture?.(event.pointerId);
    };

    const moveDrag = (event) => {
      if (!dragging) return;
      position = positionStart - (event.clientX - pointerStart);
      normalize();
    };

    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      track.releasePointerCapture?.(event.pointerId);
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(normalize, 120);
    };

    track.addEventListener('pointerdown', beginDrag);
    track.addEventListener('pointermove', moveDrag);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    window.addEventListener('resize', measure);
    requestAnimationFrame(() => {
      measure();
      requestAnimationFrame(frame);
    });
  };

  document.querySelectorAll('.trust-strip').forEach(initTrustStrip);
  document.addEventListener('shopify:section:load', (event) => initTrustStrip(event.target.querySelector('.trust-strip')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manifiesto-artesanal"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('craft-manifesto-slider')) {

    customElements.define(
      'craft-manifesto-slider',

      class CraftManifestoSlider extends HTMLElement {

        connectedCallback() {

          if (this.dataset.loopReady === 'true') {
            return;
          }

          this.dataset.loopReady = 'true';

          this.viewport =
            this.querySelector(
              '[data-slider-viewport]'
            );

          this.track =
            this.querySelector(
              '.craft-slider__track'
            );

          this.slides =
            Array.from(
              this.querySelectorAll(
                '[data-slider-slide]'
              )
            );

          this.dots =
            Array.from(
              this.querySelectorAll(
                '[data-slider-dot]'
              )
            );

          if (
            !this.viewport ||
            !this.track ||
            this.slides.length < 2
          ) {
            return;
          }

          this.slideCount =
            this.slides.length;

          this.beforeGroups = [];
          this.afterGroups = [];

          const beforeFragment =
            document.createDocumentFragment();

          const afterFragment =
            document.createDocumentFragment();

          for (
            let group = 0;
            group < 2;
            group++
          ) {

            const groupSlides = [];

            this.slides.forEach(
              (slide) => {

                const clone =
                  this.createClone(slide);

                groupSlides.push(clone);

                beforeFragment.appendChild(
                  clone
                );

              }
            );

            this.beforeGroups.push(
              groupSlides
            );

          }

          for (
            let group = 0;
            group < 2;
            group++
          ) {

            const groupSlides = [];

            this.slides.forEach(
              (slide) => {

                const clone =
                  this.createClone(slide);

                groupSlides.push(clone);

                afterFragment.appendChild(
                  clone
                );

              }
            );

            this.afterGroups.push(
              groupSlides
            );

          }

          this.track.insertBefore(
            beforeFragment,
            this.slides[0]
          );

          this.track.appendChild(
            afterFragment
          );

          this.onScroll =
            this.onScroll.bind(this);

          this.onScrollEnd =
            this.onScrollEnd.bind(this);

          this.onResize =
            this.onResize.bind(this);

          this.onKeydown =
            this.onKeydown.bind(this);

          this.onMouseEnter =
            this.stopAutoplay.bind(this);

          this.onMouseLeave =
            this.startAutoplay.bind(this);

          this.onTouchStart =
            this.stopAutoplay.bind(this);

          this.onFocusIn =
            this.stopAutoplay.bind(this);

          this.onFocusOut =
            this.handleFocusOut.bind(this);

          this.onVisibilityChange =
            this.handleVisibilityChange.bind(this);

          this.dots.forEach(
            (dot) => {

              dot.addEventListener(
                'click',
                () => {

                  this.goToLogical(
                    Number(
                      dot.dataset.index
                    )
                  );

                }
              );

            }
          );

          this.viewport.addEventListener(
            'scroll',
            this.onScroll,
            {
              passive: true
            }
          );

          if (
            'onscrollend'
            in this.viewport
          ) {

            this.viewport.addEventListener(
              'scrollend',
              this.onScrollEnd
            );

          }

          this.viewport.addEventListener(
            'keydown',
            this.onKeydown
          );

          window.addEventListener(
            'resize',
            this.onResize,
            {
              passive: true
            }
          );

          document.addEventListener(
            'visibilitychange',
            this.onVisibilityChange
          );

          window.requestAnimationFrame(
            () => {

              window.requestAnimationFrame(
                () => {

                  this.measureLoop();

                  this.teleport(
                    this.middleStart
                  );

                  this.updateDots();

                }
              );

            }
          );

          if (
            this.dataset.autoplay === 'true'
          ) {

            this.startAutoplay();

            this.addEventListener(
              'mouseenter',
              this.onMouseEnter
            );

            this.addEventListener(
              'mouseleave',
              this.onMouseLeave
            );

            this.addEventListener(
              'touchstart',
              this.onTouchStart,
              {
                passive: true
              }
            );

            this.addEventListener(
              'focusin',
              this.onFocusIn
            );

            this.addEventListener(
              'focusout',
              this.onFocusOut
            );

          }

        }

        createClone(slide) {

          const clone =
            slide.cloneNode(true);

          clone.setAttribute(
            'data-loop-clone',
            ''
          );

          clone.setAttribute(
            'aria-hidden',
            'true'
          );

          clone.removeAttribute(
            'data-slider-slide'
          );

          clone.removeAttribute(
            'data-shopify-editor-block'
          );

          clone
            .querySelectorAll(
              'a, button, input, select, textarea'
            )
            .forEach(
              (element) => {

                element.setAttribute(
                  'tabindex',
                  '-1'
                );

              }
            );

          return clone;

        }

        measureLoop() {

          if (
            !this.slides.length ||
            !this.afterGroups.length
          ) {
            return;
          }

          this.middleStart =
            this.slides[0].offsetLeft;

          const nextGroupStart =
            this.afterGroups[0][0].offsetLeft;

          this.cycleWidth =
            nextGroupStart -
            this.middleStart;

          this.slideWidth =
            this.cycleWidth /
            this.slideCount;

          this.leftResetPoint =
            this.middleStart -
            this.cycleWidth;

          this.rightResetPoint =
            this.middleStart +
            (
              this.cycleWidth * 2
            );

        }

        onScroll() {

          if (!this.dotFrame) {

            this.dotFrame =
              window.requestAnimationFrame(
                () => {

                  this.updateDots();
                  this.dotFrame = null;

                }
              );

          }

          window.clearTimeout(
            this.scrollTimer
          );

          this.scrollTimer =
            window.setTimeout(
              () => {

                this.correctLoop();

              },
              180
            );

        }

        onScrollEnd() {

          window.clearTimeout(
            this.scrollTimer
          );

          this.scrollTimer =
            window.setTimeout(
              () => {

                this.correctLoop();

              },
              40
            );

        }

        onKeydown(event) {

          if (
            event.key === 'ArrowRight'
          ) {

            event.preventDefault();
            this.stopAutoplay();
            this.goNext();

          }

          if (
            event.key === 'ArrowLeft'
          ) {

            event.preventDefault();
            this.stopAutoplay();
            this.goPrevious();

          }

        }

        updateDots() {

          if (
            !this.slideWidth ||
            this.dots.length === 0
          ) {
            return;
          }

          const physicalIndex =
            Math.round(
              this.viewport.scrollLeft /
              this.slideWidth
            );

          const logicalIndex =
            (
              (
                physicalIndex %
                this.slideCount
              ) +
              this.slideCount
            ) %
            this.slideCount;

          this.dots.forEach(
            (dot, index) => {

              const active =
                index === logicalIndex;

              dot.classList.toggle(
                'is-active',
                active
              );

              dot.setAttribute(
                'aria-current',
                active
                  ? 'true'
                  : 'false'
              );

            }
          );

        }

        correctLoop() {

          if (!this.cycleWidth) {
            this.measureLoop();
          }

          if (!this.cycleWidth) {
            return;
          }

          const current =
            this.viewport.scrollLeft;

          if (
            current <
            this.leftResetPoint
          ) {

            this.teleport(
              this.getEquivalentMiddlePosition(
                current
              )
            );

            return;

          }

          if (
            current >=
            this.rightResetPoint
          ) {

            this.teleport(
              this.getEquivalentMiddlePosition(
                current
              )
            );

          }

        }

        getEquivalentMiddlePosition(position) {

          let offset =
            position -
            this.middleStart;

          offset =
            (
              (
                offset %
                this.cycleWidth
              ) +
              this.cycleWidth
            ) %
            this.cycleWidth;

          return (
            this.middleStart +
            offset
          );

        }

        teleport(position) {

          if (!this.viewport) {
            return;
          }

          this.viewport
            .classList
            .add(
              'is-teleporting'
            );

          this.viewport.scrollLeft =
            position;

          window.requestAnimationFrame(
            () => {

              window.requestAnimationFrame(
                () => {

                  this.viewport
                    .classList
                    .remove(
                      'is-teleporting'
                    );

                  this.updateDots();

                }
              );

            }
          );

        }

        goToLogical(index) {

          if (
            !this.slideWidth ||
            !Number.isFinite(index)
          ) {
            return;
          }

          this.stopAutoplay();

          const currentPhysical =
            Math.round(
              this.viewport.scrollLeft /
              this.slideWidth
            );

          let bestIndex = null;

          let bestDistance =
            Number.POSITIVE_INFINITY;

          for (
            let group = 0;
            group < 5;
            group++
          ) {

            const candidate =
              (
                group *
                this.slideCount
              ) +
              index;

            const distance =
              Math.abs(
                candidate -
                currentPhysical
              );

            if (
              distance <
              bestDistance
            ) {

              bestDistance = distance;
              bestIndex = candidate;

            }

          }

          if (bestIndex === null) {
            return;
          }

          this.viewport.scrollTo({
            left:
              bestIndex *
              this.slideWidth,

            behavior: 'smooth'
          });

        }

        goNext() {

          if (!this.slideWidth) {
            return;
          }

          const currentPhysical =
            Math.round(
              this.viewport.scrollLeft /
              this.slideWidth
            );

          this.viewport.scrollTo({
            left:
              (
                currentPhysical +
                1
              ) *
              this.slideWidth,

            behavior: 'smooth'
          });

        }

        goPrevious() {

          if (!this.slideWidth) {
            return;
          }

          const currentPhysical =
            Math.round(
              this.viewport.scrollLeft /
              this.slideWidth
            );

          this.viewport.scrollTo({
            left:
              (
                currentPhysical -
                1
              ) *
              this.slideWidth,

            behavior: 'smooth'
          });

        }

        startAutoplay() {

          this.stopAutoplay();

          if (
            this.dataset.autoplay !==
            'true'
          ) {
            return;
          }

          if (document.hidden) {
            return;
          }

          const delay =
            Number(
              this.dataset.delay
            ) ||
            6000;

          this.timer =
            window.setInterval(
              () => {

                this.goNext();

              },
              delay
            );

        }

        stopAutoplay() {

          if (this.timer) {

            window.clearInterval(
              this.timer
            );

            this.timer = null;

          }

        }

        handleFocusOut() {

          window.setTimeout(
            () => {

              if (
                !this.contains(
                  document.activeElement
                )
              ) {

                this.startAutoplay();

              }

            },
            0
          );

        }

        handleVisibilityChange() {

          if (document.hidden) {

            this.stopAutoplay();

          } else {

            this.startAutoplay();

          }

        }

        onResize() {

          window.clearTimeout(
            this.resizeTimer
          );

          this.resizeTimer =
            window.setTimeout(
              () => {

                let logicalIndex = 0;

                const activeDot =
                  this.dots.findIndex(
                    (dot) =>
                      dot.classList.contains(
                        'is-active'
                      )
                  );

                if (activeDot >= 0) {
                  logicalIndex = activeDot;
                }

                this.measureLoop();

                this.teleport(
                  this.middleStart +
                  (
                    logicalIndex *
                    this.slideWidth
                  )
                );

              },
              180
            );

        }

        disconnectedCallback() {

          this.stopAutoplay();

          window.clearTimeout(
            this.scrollTimer
          );

          window.clearTimeout(
            this.resizeTimer
          );

          if (this.dotFrame) {

            window.cancelAnimationFrame(
              this.dotFrame
            );

          }

          if (this.viewport) {

            this.viewport.removeEventListener(
              'scroll',
              this.onScroll
            );

            this.viewport.removeEventListener(
              'scrollend',
              this.onScrollEnd
            );

            this.viewport.removeEventListener(
              'keydown',
              this.onKeydown
            );

          }

          this.removeEventListener(
            'mouseenter',
            this.onMouseEnter
          );

          this.removeEventListener(
            'mouseleave',
            this.onMouseLeave
          );

          this.removeEventListener(
            'touchstart',
            this.onTouchStart
          );

          this.removeEventListener(
            'focusin',
            this.onFocusIn
          );

          this.removeEventListener(
            'focusout',
            this.onFocusOut
          );

          window.removeEventListener(
            'resize',
            this.onResize
          );

          document.removeEventListener(
            'visibilitychange',
            this.onVisibilityChange
          );

        }

      }

    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    

if (
  !customElements.get(
    'related-premium-carousel'
  )
) {

  customElements.define(
    'related-premium-carousel',

    class RelatedPremiumCarousel
      extends HTMLElement {


      connectedCallback() {

        this.querySelectorAll(
          '[data-carousel-loop-clone]'
        ).forEach(
          (clone) => clone.remove()
        );


        this.viewport =
          this.querySelector(
            '[data-carousel-viewport]'
          );


        this.track =
          this.querySelector(
            '[data-carousel-track]'
          );


        this.slides =
          Array.from(
            this.querySelectorAll(
              '[data-carousel-slide]'
            )
          );


        this.dots =
          Array.from(
            this.querySelectorAll(
              '[data-carousel-dot]'
            )
          );


        if (
          !this.viewport ||
          !this.track ||
          this.slides.length === 0
        ) {
          return;
        }


        this.slideCount =
          this.slides.length;


        if (
          this.slideCount < 2
        ) {

          this.setDot(
            0
          );

          return;

        }


        this.isTouching =
          false;


        this.isRecentering =
          false;


        this.scrollTimer =
          null;


        this.resizeTimer =
          null;


        this.dotFrame =
          null;


        this.lastDotScrollLeft =
          null;


        this.slides.forEach(
          (slide, index) => {

            slide.dataset.logicalIndex =
              index;

          }
        );


        this.beforeGroups =
          [];


        this.afterGroups =
          [];


        const beforeFragment =
          document.createDocumentFragment();


        const afterFragment =
          document.createDocumentFragment();


        /* ==================================================
           DOS COPIAS ANTES
        ================================================== */

        for (
          let group = 0;
          group < 2;
          group++
        ) {

          const currentGroup =
            [];


          this.slides.forEach(
            (slide, index) => {

              const clone =
                this.createClone(
                  slide,
                  index
                );


              currentGroup.push(
                clone
              );


              beforeFragment.appendChild(
                clone
              );

            }
          );


          this.beforeGroups.push(
            currentGroup
          );

        }


        /* ==================================================
           DOS COPIAS DESPUÉS
        ================================================== */

        for (
          let group = 0;
          group < 2;
          group++
        ) {

          const currentGroup =
            [];


          this.slides.forEach(
            (slide, index) => {

              const clone =
                this.createClone(
                  slide,
                  index
                );


              currentGroup.push(
                clone
              );


              afterFragment.appendChild(
                clone
              );

            }
          );


          this.afterGroups.push(
            currentGroup
          );

        }


        this.track.insertBefore(
          beforeFragment,
          this.slides[0]
        );


        this.track.appendChild(
          afterFragment
        );


        /* ==================================================
           DOTS
        ================================================== */

        this.dots.forEach(
          (dot) => {

            dot.addEventListener(
              'click',

              () => {

                this.goToLogical(
                  Number(
                    dot.dataset.index
                  )
                );

              }
            );

          }
        );


        /* ==================================================
           EVENTS
        ================================================== */

        this.onScroll =
          this.onScroll.bind(this);


        this.onScrollEnd =
          this.onScrollEnd.bind(this);


        this.onTouchStart =
          this.onTouchStart.bind(this);


        this.onTouchEnd =
          this.onTouchEnd.bind(this);


        this.onResize =
          this.onResize.bind(this);


        this.viewport.addEventListener(
          'scroll',
          this.onScroll,
          {
            passive: true
          }
        );


        if (
          'onscrollend'
          in this.viewport
        ) {

          this.viewport.addEventListener(
            'scrollend',
            this.onScrollEnd
          );

        }


        this.viewport.addEventListener(
          'touchstart',
          this.onTouchStart,
          {
            passive: true
          }
        );


        this.viewport.addEventListener(
          'touchend',
          this.onTouchEnd,
          {
            passive: true
          }
        );


        this.viewport.addEventListener(
          'touchcancel',
          this.onTouchEnd,
          {
            passive: true
          }
        );


        window.addEventListener(
          'resize',
          this.onResize,
          {
            passive: true
          }
        );


        /* ==================================================
           POSICIÓN INICIAL
        ================================================== */

        window.requestAnimationFrame(
          () => {

            window.requestAnimationFrame(
              () => {

                this.measure();


                this.instantMove(
                  this.middleStart
                );


                this.updateDotFromScroll();

              }
            );

          }
        );

      }


      /* ==================================================
         CREAR CLON
      ================================================== */

      createClone(
        slide,
        logicalIndex
      ) {

        const clone =
          slide.cloneNode(
            true
          );


        clone.setAttribute(
          'data-carousel-loop-clone',
          ''
        );


        clone.dataset.logicalIndex =
          logicalIndex;


        clone.removeAttribute(
          'data-carousel-slide'
        );


        clone.setAttribute(
          'aria-hidden',
          'true'
        );


        clone.querySelectorAll(
          'a, button, input, select, textarea'
        ).forEach(
          (element) => {

            element.setAttribute(
              'tabindex',
              '-1'
            );

          }
        );


        return clone;

      }


      /* ==================================================
         MEDIDAS
      ================================================== */

      measure() {

        if (
          !this.afterGroups.length
        ) {
          return;
        }


        this.middleStart =
          this.slides[0]
            .offsetLeft;


        const nextCycleStart =
          this.afterGroups[0][0]
            .offsetLeft;


        this.cycleWidth =
          nextCycleStart -
          this.middleStart;


        if (
          !this.cycleWidth ||
          this.cycleWidth <= 0
        ) {
          return;
        }


        this.step =
          this.cycleWidth /
          this.slideCount;


        this.leftTrigger =
          this.middleStart -
          (
            this.step *
            0.55
          );


        this.rightTrigger =
          this.middleStart +
          this.cycleWidth -
          (
            this.step *
            0.45
          );

      }


      /* ==================================================
         TOUCH
      ================================================== */

      onTouchStart() {

        this.isTouching =
          true;


        this.lastDotScrollLeft =
          this.viewport.scrollLeft;


        window.clearTimeout(
          this.scrollTimer
        );

      }


      onTouchEnd() {

        this.isTouching =
          false;


        this.scheduleScrollEnd();

      }


      /* ==================================================
         SCROLL
      ================================================== */

      onScroll() {

        if (
          this.isRecentering
        ) {
          return;
        }


        if (
          !this.dotFrame
        ) {

          this.dotFrame =
            window.requestAnimationFrame(
              () => {

                this.updateDotFromScroll();


                this.dotFrame =
                  null;

              }
            );

        }


        if (
          !this.isTouching
        ) {

          this.scheduleScrollEnd();

        }

      }


      /* ==================================================
         SCROLL END FALLBACK
      ================================================== */

      scheduleScrollEnd() {

        window.clearTimeout(
          this.scrollTimer
        );


        this.scrollTimer =
          window.setTimeout(
            () => {

              if (
                this.isTouching ||
                this.isRecentering
              ) {
                return;
              }


              this.recenterIfNeeded();

            },
            180
          );

      }


      /* ==================================================
         SCROLLEND
      ================================================== */

      onScrollEnd() {

        if (
          this.isTouching ||
          this.isRecentering
        ) {
          return;
        }


        window.clearTimeout(
          this.scrollTimer
        );


        window.requestAnimationFrame(
          () => {

            if (
              !this.isTouching
            ) {

              this.recenterIfNeeded();

            }

          }
        );

      }


      /* ==================================================
         DOT ACTIVO
         RESPUESTA RÁPIDA DURANTE EL SWIPE
      ================================================== */

      updateDotFromScroll() {

        if (
          !this.step ||
          this.dots.length === 0
        ) {
          return;
        }


        const currentScroll =
          this.viewport.scrollLeft;


        const position =
          (
            currentScroll -
            this.middleStart
          ) /
          this.step;


        let rawIndex;


        /*
          El punto cambia cuando el gesto ha
          avanzado aproximadamente un 25%
          hacia el siguiente producto.

          Antes se usaba Math.round(), por lo
          que esperaba al 50% y visualmente
          parecía ir con retraso.
        */

        if (
          typeof this.lastDotScrollLeft !==
          'number'
        ) {

          rawIndex =
            Math.round(
              position
            );

        } else {

          const movement =
            currentScroll -
            this.lastDotScrollLeft;


          if (
            movement >
            0.25
          ) {

            rawIndex =
              Math.floor(
                position +
                0.75
              );

          } else if (
            movement <
            -0.25
          ) {

            rawIndex =
              Math.ceil(
                position -
                0.75
              );

          } else {

            rawIndex =
              Math.round(
                position
              );

          }

        }


        this.lastDotScrollLeft =
          currentScroll;


        const logicalIndex =
          this.mod(
            rawIndex,
            this.slideCount
          );


        this.setDot(
          logicalIndex
        );

      }


      setDot(
        logicalIndex
      ) {

        this.dots.forEach(
          (dot, index) => {

            const active =
              index ===
              logicalIndex;


            dot.classList.toggle(
              'is-active',
              active
            );


            dot.setAttribute(
              'aria-current',
              active
                ? 'true'
                : 'false'
            );

          }
        );

      }


      /* ==================================================
         RECENTRADO
      ================================================== */

      recenterIfNeeded() {

        if (
          !this.cycleWidth ||
          !this.step
        ) {
          return;
        }


        const current =
          this.viewport.scrollLeft;


        if (
          current >=
          this.rightTrigger
        ) {

          this.instantMove(
            this.getEquivalentMiddlePosition(
              current
            )
          );


          return;

        }


        if (
          current <=
          this.leftTrigger
        ) {

          this.instantMove(
            this.getEquivalentMiddlePosition(
              current
            )
          );

        }

      }


      /* ==================================================
         POSICIÓN CENTRAL EQUIVALENTE
      ================================================== */

      getEquivalentMiddlePosition(
        position
      ) {

        const offset =
          this.mod(
            position -
            this.middleStart,
            this.cycleWidth
          );


        return (
          this.middleStart +
          offset
        );

      }


      /* ==================================================
         MOVIMIENTO INSTANTÁNEO
      ================================================== */

      instantMove(
        position
      ) {

        if (
          !this.viewport
        ) {
          return;
        }


        this.isRecentering =
          true;


        this.viewport.classList.add(
          'is-recentering'
        );


        /*
          Muy importante:
          sincronizamos también la posición
          usada para calcular el punto activo.
          Así el recentrado invisible del loop
          no se interpreta como un swipe.
        */

        this.lastDotScrollLeft =
          position;


        this.viewport.scrollLeft =
          position;


        window.requestAnimationFrame(
          () => {

            this.viewport.classList.remove(
              'is-recentering'
            );


            this.isRecentering =
              false;


            this.updateDotFromScroll();

          }
        );

      }


      /* ==================================================
         CLICK DOT
      ================================================== */

      goToLogical(
        logicalIndex
      ) {

        if (
          !this.step ||
          !Number.isFinite(
            logicalIndex
          )
        ) {
          return;
        }


        const currentRawIndex =
          Math.round(
            (
              this.viewport.scrollLeft -
              this.middleStart
            ) /
            this.step
          );


        let bestRawIndex =
          logicalIndex;


        let bestDistance =
          Number.POSITIVE_INFINITY;


        for (
          let cycle = -2;
          cycle <= 2;
          cycle++
        ) {

          const candidate =
            logicalIndex +
            (
              cycle *
              this.slideCount
            );


          const distance =
            Math.abs(
              candidate -
              currentRawIndex
            );


          if (
            distance <
            bestDistance
          ) {

            bestDistance =
              distance;


            bestRawIndex =
              candidate;

          }

        }


        const target =
          this.middleStart +
          (
            bestRawIndex *
            this.step
          );


        /*
          Guardamos la posición actual antes
          del movimiento para que la dirección
          se detecte desde el primer frame.
        */

        this.lastDotScrollLeft =
          this.viewport.scrollLeft;


        this.viewport.scrollTo({

          left:
            target,

          behavior:
            'smooth'

        });

      }


      /* ==================================================
         MOD POSITIVO
      ================================================== */

      mod(
        value,
        divisor
      ) {

        return (
          (
            value %
            divisor
          ) +
          divisor
        ) %
        divisor;

      }


      /* ==================================================
         RESIZE
      ================================================== */

      onResize() {

        window.clearTimeout(
          this.resizeTimer
        );


        this.resizeTimer =
          window.setTimeout(
            () => {

              let logicalIndex =
                0;


              const activeDotIndex =
                this.dots.findIndex(
                  (dot) =>
                    dot.classList.contains(
                      'is-active'
                    )
                );


              if (
                activeDotIndex >= 0
              ) {

                logicalIndex =
                  activeDotIndex;

              }


              this.measure();


              if (
                this.step
              ) {

                this.instantMove(
                  this.middleStart +
                  (
                    logicalIndex *
                    this.step
                  )
                );

              }

            },
            180
          );

      }


      /* ==================================================
         CLEANUP
      ================================================== */

      disconnectedCallback() {

        window.clearTimeout(
          this.scrollTimer
        );


        window.clearTimeout(
          this.resizeTimer
        );


        if (
          this.dotFrame
        ) {

          window.cancelAnimationFrame(
            this.dotFrame
          );

        }


        if (
          this.viewport
        ) {

          this.viewport.removeEventListener(
            'scroll',
            this.onScroll
          );


          this.viewport.removeEventListener(
            'scrollend',
            this.onScrollEnd
          );


          this.viewport.removeEventListener(
            'touchstart',
            this.onTouchStart
          );


          this.viewport.removeEventListener(
            'touchend',
            this.onTouchEnd
          );


          this.viewport.removeEventListener(
            'touchcancel',
            this.onTouchEnd
          );

        }


        window.removeEventListener(
          'resize',
          this.onResize
        );

      }

    }

  );

}


  } catch(e) { console.error(e); }
})();
})();
